export const WEEK_DAYS = [
    { value: "MONDAY", label: "Lundi" },
    { value: "TUESDAY", label: "Mardi" },
    { value: "WEDNESDAY", label: "Mercredi" },
    { value: "THURSDAY", label: "Jeudi" },
    { value: "FRIDAY", label: "Vendredi" },
    { value: "SATURDAY", label: "Samedi" },
    { value: "SUNDAY", label: "Dimanche" }
];

const DAY_LABELS = Object.fromEntries(WEEK_DAYS.map((day) => [day.value, day.label]));

export const DEFAULT_OPENING_HOURS = {
    dayStart: "MONDAY",
    dayEnd: "SUNDAY",
    openTime: "08:00",
    closeTime: "19:00",
    comment: "Nous sommes disponible par telephone / Whatsapp 24h/24"
};

export function formatTimeFr(time) {
    if (!time) {
        return "";
    }
    const [hours, minutes] = time.split(":");
    return `${hours}h${minutes}`;
}

export function formatOpeningHours(openingHours) {
    if (!openingHours?.dayStart || !openingHours?.dayEnd || !openingHours?.openTime || !openingHours?.closeTime) {
        return "";
    }

    const startLabel = DAY_LABELS[openingHours.dayStart]?.toLowerCase() || openingHours.dayStart;
    const endLabel = DAY_LABELS[openingHours.dayEnd]?.toLowerCase() || openingHours.dayEnd;
    const sameDay = openingHours.dayStart === openingHours.dayEnd;

    const dayPart = sameDay
        ? `Le ${startLabel}`
        : `Du ${startLabel} au ${endLabel}`;

    return `${dayPart}, de ${formatTimeFr(openingHours.openTime)} à ${formatTimeFr(openingHours.closeTime)}`;
}

export function isDayBeforeOrEqual(dayStart, dayEnd) {
    const startIndex = WEEK_DAYS.findIndex((day) => day.value === dayStart);
    const endIndex = WEEK_DAYS.findIndex((day) => day.value === dayEnd);
    return startIndex >= 0 && endIndex >= 0 && startIndex <= endIndex;
}
